import React from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import serialize from 'form-serialize';
import { Link } from 'react-router-dom';
import SignupForm from './signup-form';
import { Variant } from './types';

interface Props {
  className?: string;
  description: string;
  buttonText?: string;
  title: string;
  buttonClass?: string;
  stacked?: boolean;
  variant?: Variant;
}

interface State {
  email?: string;
  feedback?: string;
  isSubscribed: boolean;
  loading: boolean;
}

class NewsletterSignupContainer extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
      feedback: '',
      isSubscribed: false,
      loading: false,
    };
  }

  subscribeNewsletter = (email: string) =>
    fetch(`/_internal/newsletter/subscribe`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    }).then(res => res.json());

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const formData = serialize(e.target, { hash: true });

    e.preventDefault();

    if (formData.email) {
      this.setState({ loading: true });
      this.subscribeNewsletter(formData.email)
        .then(res => {
          this.setState({
            isSubscribed: res.success,
            feedback: res.success
              ? 'newsletter.sign-up-success'
              : 'newsletter.sign-up-error',
            loading: false,
          });
        })
        .catch(() => {
          this.setState({
            feedback: 'newsletter.sign-up-error',
            loading: false,
          });
        });
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;

    this.setState({
      ...this.state,
      [target.name]: target.value,
    });
  };

  getPrivacyUrl = () => {
    const { market, renderMode } = this.context;
    return (
      market.privacySettings[renderMode] || market.privacySettings.responsive
    ).privacyUrl;
  };

  render() {
    const { t } = this.context;
    const { email, feedback, isSubscribed, loading } = this.state;
    const {
      className,
      title,
      description,
      buttonText,
      buttonClass,
      stacked,
      variant,
    } = this.props;
    const privacyPolicyUri = this.getPrivacyUrl();

    return (
      <SignupForm
        className={className}
        isSubscribed={isSubscribed}
        loading={loading}
        email={email}
        onSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={title}
        description={description}
        buttonText={buttonText || t('campaigns', 'newsletter.sign-up-button')}
        feedbackText={t('campaigns', feedback)}
        legalText={
          privacyPolicyUri && (
            <Link
              to={privacyPolicyUri}
              // This link is nofollow to avoid it getting too much of the internal
              // pagerank (since it occurs on every page).
              rel="nofollow"
            >
              {t('product', 'alert.how-your-email-is-used')}
            </Link>
          )
        }
        subscribeTextTitle={t('campaigns', 'newsletter.sign-up-success')}
        buttonClass={buttonClass}
        stacked={stacked}
        variant={variant}
      />
    );
  }
}

NewsletterSignupContainer.contextType = AppContext;

export default NewsletterSignupContainer;
